import { Component, effect, OnInit } from '@angular/core';
import { MotorQuoteStateService } from 'src/app/services/motor-quote-state/motor-quote-state.service';
import { QuoteDetailsService } from 'src/app/services/quote-details-service/quote-details.service';
import { NgClass, NgOptimizedImage, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    imports: [NgClass, NgOptimizedImage]
})
export class HeaderComponent implements OnInit {

    quotePrice: any;
    isQuoteDetailsPage: boolean = false;
    isExcessAfterFirstStepQuote: boolean = false;

    constructor(
        private readonly motorQuoteStateService: MotorQuoteStateService,
        private readonly quoteDetailsService: QuoteDetailsService
    ) {

        effect(() => {
            this.isQuoteDetailsPage = this.motorQuoteStateService.isQuoteDetailsPage();
            this.setAnnualPrice();

            this.isExcessAfterFirstStepQuote = this.motorQuoteStateService.isExcessAfterFirstStepQuote()
        });
    }

    ngOnInit() {
        this.isExcessAfterFirstStepQuote = this.motorQuoteStateService.isExcessAfterFirstStepQuote()
    }

    private setAnnualPrice(): void {
        if (this.isQuoteDetailsPage) {
            this.quotePrice = this.quoteDetailsService.getTotalPrice();
        }
    }

    /** 
     * Detct is ipad or iphone
     * if iphone and forms are filled up confirmation dialog is askeked to leave site
     **/
    leaveSite() {
        location.assign('/');
    }

}
